import { GraphApiMethod, GraphApiResponse } from '@/api/core';
import { HandleErrorInput, handleError, queryInput } from '@/utils/custom';
import { UpdateCombineRuleHistoryInput, UpdateCombineRuleHistoryValuesInput } from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { UpdateCombineRuleHistoryBulkDocument } from '@/api/queries';
import graphApi from '@/api';

export type CombineRuleHistoryUpdate = Partial<UpdateCombineRuleHistoryValuesInput> & { id: string };
// Global Service Variables
const onError = (res: HandleErrorInput): void => handleError(res, { notification: { title: 'Update Combine Rule Setting' } });

// Service Function Signature
type ServiceMethodPayload = CombineRuleHistoryUpdate[];
interface ServiceMethod {
  (payload: ServiceMethodPayload): Promise<GraphApiResponse>;
}

// UpdateCombineRuleHistoryBulk Service
export const { updateCombineRuleHistoryBulk, useUpdateCombineRuleHistoryBulk } = ((): {
  updateCombineRuleHistoryBulk: ServiceMethod;
  useUpdateCombineRuleHistoryBulk: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [mutate] = graphApi(UpdateCombineRuleHistoryBulkDocument, {
    onError,
  }).map(
    (fn: GraphApiMethod<typeof UpdateCombineRuleHistoryBulkDocument>): ServiceMethod =>
      async (payload: ServiceMethodPayload): Promise<GraphApiResponse> => {
        const updates: UpdateCombineRuleHistoryInput[] = payload.map(
          ({ id, combineRuleId, discount, startDatetime }): UpdateCombineRuleHistoryInput => ({
            query: [{ id: queryInput(id) }],
            value: { combineRuleId, discount, startDatetime },
          })
        );
        const res = await fn({ input: { updates } });
        return res;
      }
  );

  const useService = createGraphApiHook(mutate, { bubble: true });
  return {
    updateCombineRuleHistoryBulk: mutate,
    useUpdateCombineRuleHistoryBulk: useService,
  };
})();
